import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const CommunityContext = createContext(null);

export function CommunityProvider({ children }) {
  const [communities, setCommunities] = useState([]);
  const [slug, setSlug] = useState(localStorage.getItem("gemeinde_slug") || "");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/communities")
      .then(({ data }) => {
        setCommunities(data || []);
        setSlug((current) => {
          const exists = (data || []).some((c) => c.slug === current);
          return exists ? current : (data || [])[0]?.slug || "";
        });
      })
      .catch(() => setCommunities([]))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (slug) localStorage.setItem("gemeinde_slug", slug);
  }, [slug]);

  const community = useMemo(() => communities.find((c) => c.slug === slug) || null, [communities, slug]);

  useEffect(() => {
    if (!community) return;
    const root = document.documentElement;
    root.style.setProperty("--brand", community.primary_color || "#2F4A3C");
    root.style.setProperty("--brand-soft", community.secondary_color || "#F2EDE3");
    root.style.setProperty("--brand-accent", community.accent_color || "#C4703A");
  }, [community]);

  return (
    <CommunityContext.Provider value={{ communities, community, slug, setSlug, loading }}>
      {children}
    </CommunityContext.Provider>
  );
}

export const useCommunity = () => useContext(CommunityContext);
